var React = require('react');
var ReactNative = require('react-native');

var LinkingManager = require('./wrappers/LinkingManager');
var NetworkManager = require('./NetworkManager');

var {
  View,
  StyleSheet,
  Platform,
} = ReactNative;

var Instagram = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {

    }
  },

  getInitialState : function()
  {
    return {

    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  render: function()
  {
    return (<View />)
  }
});

Instagram.getCards = function(featureData, appActions, data)
{
  var didSelect = function(index)
  {
    Instagram.customNavigation(featureData, appActions);
  };
  var imageURLs = [];
  var MAX_NUM_INSTAGRAM = 5;
  if( typeof data.Instagrams !== 'undefined' )
  {
    data.Instagrams = data.Instagrams.sort(function(a,b)
    {
      return b.created_time - a.created_time;
    });
    var numAdded = 0;
    for( var i = 0; i < data.Instagrams.length && numAdded < MAX_NUM_INSTAGRAM; i++ )
    {
      var insta = data.Instagrams[i];
      var imageURL = insta.images.low_resolution.url;
      var foundImageURL = false;
      for( var j = 0; j < imageURLs.length; j++ )
      {
        if(imageURLs[j] == imageURL )
        {
          foundImageURL = true;
          break;
        }
      }
      if( !foundImageURL && typeof imageURL !== 'undefined' && imageURL.length > 0 )
      {
        // alert(imageURLs)
        imageURLs.push(imageURL);
        numAdded++;
      }
    }
    var appManager = appActions._appManager;
    didSelect = function(index)
    {
      if( typeof data !== 'undefined' && typeof data.Instagrams !== 'undefined' && data.Instagrams.length > index )
      {
        var url = data.Instagrams[index].link;
        var barTintColor = appManager.getColorForKey("HeaderColor");
        var tintColor = appManager.getColorForKey("HeaderIconColor");
        LinkingManager.openURL(url, tintColor, barTintColor);
      }
      else
      {
        Instagram.customNavigation(featureData, appActions);
      }
    };
  }

  if( imageURLs.length <= 0 ) return [];

  var iconName = featureData.data.icon.replace("fa-", "")
  var sortOrder = ((new Date()).getTime()) - (data.Instagrams[0].created_time*1000);
  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : featureData.data.tip,
    icon : iconName,
    cardType : 7,
    imageURLs : imageURLs,
    sortOrder : sortOrder
  }];
}
Instagram.customNavigation = function(featureData, appActions)
{
  var instagramURL = "instagram://user?username="+featureData.data.instagram_user_id;
  LinkingManager.canOpenURL(instagramURL, function(can)
  {
    if( can )
    {
      LinkingManager.openURL(instagramURL)
    }
    else
    {
      var url = "http://www.instagram.com/"+featureData.data.instagram_user_id;
      var appManager = appActions._appManager;
      var barTintColor = appManager.getColorForKey("HeaderColor");
      var tintColor = appManager.getColorForKey("HeaderIconColor");

      LinkingManager.openURL(url, tintColor, barTintColor);
    }
  })
}

Instagram.dataDependencies = ["Instagrams"];

module.exports = Instagram;
